export default "__VITE_ASSET__DJxxx48u__"